
//import data from "./articles/demo";
//import data from "./articles/miljopartiet";
// import data from "./articles/brexit";
//import data from "./articles/hedersmord";
//import data from "./articles/hyrestestet";
//import data from "./articles/hyrestestet-tack";
//import data from "./articles/zika";
//import data from "./articles/zikatimeline";
//import data from "./articles/historien-om-zika";
//import data from "./articles/flight";
//import data from "./articles/utslapp";
//import data from "./articles/efterflykten-bakgrund";
// import data from "./articles/kulturkartan-kommunala-kultursatsningar-2015";
// import data from "./articles/estland-fentanyl";
// import data from "./articles/vem-sa-vad-i-tredje-presidentvals-debatten";
import data from "./articles/brexit";
//import data from "./articles/min-van-tiggaren";
// import data from "./articles/airbus-a320";
//import data from "./articles/en-hel-by-tystnar";
// import data from "./articles/krisen-i-miljopartiet";
//import data from "./articles/gammal-bil";
//import data from "./articles/efter-flykten";
//import data from "./articles/efterflykten-bakgrund";
//import data from "./articles/efter-flykten-mottagandet";
//import data from "./articles/efter-flykten-jobben";
//import data from "./articles/efter-flykten-skolan";
//import data from "./articles/dammolyckan-i-brasilien";
// import data from "./articles/fem-ar-efter-otoya";
// import data from "./articles/is-fore-efter";
// import data from "./articles/usagrafik";
// import data from "./articles/usa-swingstates";
// import data from "./articles/usa-valnatt-grafik";
// import data from "./articles/flygplanskrascher-2016";
// import data from "./articles/kent_next";
// import data from "./articles/aret-2017-i-bilder";
// import data from "./articles/annika-beijbom";
// import data from "./articles/trumps-liv-i-bilder";
// import data from "./articles/trumps-viktigaste-spelare";
// import data from "./articles/pejl-projekt";
//import data from "./articles/opinionsbildaren-magnus-betner";
//import data from "./articles/opinionsbildaren-kent-wisti";
// import data from "./articles/opinionsbildaren-clara-lidstrom";
// import data from "./articles/opinionsbildaren-rebecca-weidmo-uvell";
// import data from "./articles/valjarbarometern";
// import data from "./articles/nicar2017";
// import data from "./articles/kvinnodagen-2017";
//import data from "./articles/frankrike-presidentmakt";
//import data from "./articles/lasse-tog-sitt-liv";
// import data from "./articles/livegranskning-smabrott";
//import data from "./articles/m-krisen-bakom-kulisserna";
// import data from "./articles/mansour";
//import data from "./articles/test";
// import data from "./articles/sameval-test";
// import data from "./articles/morden-i-malmo-2017";

export default data;



/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/data/index.js
 **/